export const enum PeriodSelector {
  Monthly = 'Monthly',
  Quarterly = 'Quarterly',
  Annually = 'Annually',
}

export const enum Quarter {
  Q1 = 1,
  Q2 = 2,
  Q3 = 3,
  Q4 = 4,
}

export const enum Month {
  January = 'January',
  February = 'February',
  March = 'March',
  April = 'April',
  May = 'May',
  June = 'June',
  July = 'July',
  August = 'August',
  September = 'September',
  October = 'October',
  November = 'November',
  December = 'December',
}

export const MONTH_QUARTERLY_OPTIONS = [
  {
    label: 'Q1 (Jan - March)',
    value: String(Quarter.Q1),
  },
  {
    label: 'Q2 (Apr - June)',
    value: String(Quarter.Q2),
  },
  {
    label: 'Q3 (Jul - Sept)',
    value: String(Quarter.Q3),
  },
  {
    label: 'Q4 (Oct - Dec)',
    value: String(Quarter.Q4),
  },
];

export const MONTH_OPTIONS = [
  {
    label: Month.January,
    value: Month.January,
  },
  {
    label: Month.February,
    value: Month.February,
  },
  {
    label: Month.March,
    value: Month.March,
  },
  {
    label: Month.April,
    value: Month.April,
  },
  {
    label: Month.May,
    value: Month.May,
  },
  {
    label: Month.June,
    value: Month.June,
  },
  {
    label: Month.July,
    value: Month.July,
  },
  {
    label: Month.August,
    value: Month.August,
  },
  {
    label: Month.September,
    value: Month.September,
  },
  {
    label: Month.October,
    value: Month.October,
  },
  {
    label: Month.November,
    value: Month.November,
  },
  {
    label: Month.December,
    value: Month.December,
  },
];
